import { Fallback, FallbackType } from '../enums';

export const getDefaultFallback = (): Fallback => ({
  method: FallbackType.None,
  targetField: undefined,
  collectionId: undefined,
  sortingOrder: undefined,
});
